import {Col} from "antd"
import {Icon} from "components"
import {AttendanceErrorLogType, AttendanceIssueItem, AttendanceIssues} from "../AttendanceIssues"
import {PracticalIssues} from "../PracticalIssues"
import {PracticalIssueItem} from "../PracticalIssues/PracticalIssues"
import styles from "../../HomePage.module.css"
import {useQuery} from "@tanstack/react-query"
import {reportsService} from "services"
import {get} from "lodash"
import moment from "moment"
import {useModel} from "hooks"
import {useMemo} from "react"

export enum PracticalAndGradesErrorLogType {
    Practical = "Practical",
    Grades = "Grades"
}

export function AcademicErrorLogView() {
    const model = useModel()
    const defaultCampuses = useMemo(() => model.getCurrentUserProfile()?.campuses ?? [], [model])

    const {data} = useQuery(
        ["get-academic-error-log", defaultCampuses],
        async () =>
            reportsService.getAcademicErrorLog({
                campusIds: defaultCampuses.map((item) => item.id)
            }),
        {
            enabled: true
        }
    )

    const attendanceIssues: AttendanceIssueItem[] = [
        {
            icon: "SYNC_ERROR",
            label: "Sync Error",
            color: "#fa8c16",
            attendanceErrorLogType: AttendanceErrorLogType.SyncError
        },
        {
            icon: "WARNING_TRIANGLE_FILL",
            label: "Overlapping Punch",
            color: "#fa8c16",
            attendanceErrorLogType: AttendanceErrorLogType.OverlappingTime
        },
        {
            icon: "WARNING_TRIANGLE_FILL",
            label: "Has Triangle Alert",
            color: "#faad14",
            attendanceErrorLogType: AttendanceErrorLogType.HasTriangleAlert
        },
        {
            icon: "CHECKOUT_FILL",
            label: "Missing Checkout",
            color: "#1890ff",
            attendanceErrorLogType: AttendanceErrorLogType.MissingCheckout
        },
        {
            icon: "CHECKIN_FILL",
            label: "Missing Checkin",
            color: "#52c41a",
            attendanceErrorLogType: AttendanceErrorLogType.MissingCheckin
        }
    ].map((attendanceIssue) => {
        let count = 0
        if (attendanceIssue.attendanceErrorLogType === AttendanceErrorLogType.SyncError) {
            count = get(data, ["dailyAttendance", "notSynced"], 0)
        } else if (attendanceIssue.attendanceErrorLogType === AttendanceErrorLogType.OverlappingTime) {
            count = get(data, ["dailyAttendance", "overlappingTime"], 0)
        } else if (attendanceIssue.attendanceErrorLogType === AttendanceErrorLogType.HasTriangleAlert) {
            count = get(data, ["dailyAttendance", "hasTriangleAlert"], 0)
        } else if (attendanceIssue.attendanceErrorLogType === AttendanceErrorLogType.MissingCheckout) {
            count = get(data, ["dailyAttendance", "missingCheckout"], 0)
        } else {
            count = get(data, ["dailyAttendance", "missingCheckin"], 0)
        }

        return {
            ...attendanceIssue,
            count
        }
    })

    const practicalIssues: PracticalIssueItem[] = [
        {
            icon: "SYNC_ERROR",
            label: "Practical Sync Error",
            color: "#fa8c16",
            type: PracticalAndGradesErrorLogType.Practical
        },
        {icon: "SYNC_ERROR", label: "Grades Sync Error", color: "#fa8c16", type: PracticalAndGradesErrorLogType.Grades}
    ].map((attendanceIssue, index) => {
        if (attendanceIssue.type === PracticalAndGradesErrorLogType.Practical) {
            let count = get(data, ["fameGrade", "gradeExportNotSynced"], 0)

            return {
                ...attendanceIssue,
                count
            }
        } else {
            let count = get(data, ["fameGrade", "fameGradeExportNotSynced"], 0)

            return {
                ...attendanceIssue,
                count
            }
        }
    })

    return (
        <Col span={24}>
            <div className={styles.card}>
                <div className={styles.cardHeader}>
                    <Icon icon="INFO" />
                    <p className={styles.cardTitle}>Attendance</p>
                </div>
                <AttendanceIssues attendanceIssues={attendanceIssues} />
                <div className={styles.cardHeader}>
                    <Icon icon="INFO" />
                    <p className={styles.cardTitle}>Practical And Grades</p>
                </div>
                <PracticalIssues practicalIssues={practicalIssues} />
            </div>
        </Col>
    )
}
